import { AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router} from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Subscription} from "rxjs";
import { NivelacionesService} from "../_services/nivelaciones.service";
import { Title} from "@angular/platform-browser";
import { CustomAlertService} from "../../../_components/custom-alert/custom-alert.service";
import { DynamicBarService} from "../../../_components/dynamic-bar/dynamic-bar.service";

@Component({
  selector: 'nivelaciones-alumno',
  standalone: false,
  templateUrl: 'nivelaciones-alumno.component.html',
  styleUrls: ['./nivelaciones-alumno.component.scss', '../citacion-materia-curso/citacion-materia-curso.component.scss',
    '../../estudio/materias-familia/materia-unidades/materia-unidades.component.scss']
})

export class NivelacionesAlumnoComponent implements OnInit, AfterViewInit, OnDestroy {
  mesesDisponibles = [
    {id: 8, label: 'Agosto', shortLabel: 'Ago'},
    {id: 9, label: 'Septiembre', shortLabel: 'Sep'},
    {id: 10, label: 'Octubre', shortLabel: 'Oct'},
    {id: 11, label: 'Noviembre', shortLabel: 'Nov'},
    {id: 12, label: 'Diciembre', shortLabel: 'Dic'},
    {id: 1, label: 'Enero', shortLabel: 'Ene'},
    {id: 2, label: 'Febrero', shortLabel: 'Feb'},
    {id: 3, label: 'Marzo', shortLabel: 'Mar'},
    {id: 4, label: 'Abril', shortLabel: 'Abr'},
    {id: 5, label: 'Mayo', shortLabel: 'May'},
    {id: 6, label: 'Junio', shortLabel: 'Jun'},
  ];

  mesSeleccionado: number = 4;

  nivelaciones = [];

  nivelacionesSubscriber: Subscription;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private nivelacionesService: NivelacionesService,
              private snackBar: MatSnackBar,
              private customAlertService: CustomAlertService,
              private dynamicBarService: DynamicBarService,
              private titleService: Title) {
  }

  ngOnInit() {
    this.route.data.subscribe((
      data: {
        nivelaciones: any
      }
    ) => {
      this.nivelaciones = data.nivelaciones;
    });

    this.nivelacionesSubscriber = this.nivelacionesService.getServiceObservable().subscribe((data) => {
      if (!data) {
        return false;
      }
    });

    this.mesSeleccionado = +this.route.snapshot.paramMap.get('idMes');

    this.titleService.setTitle('Autogestión - Nivelaciones');

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngAfterViewInit() {
    this.dynamicBarService.setBarra('nivelaciones-alumno-barra');
  }

  ngOnDestroy() {
    if (this.nivelacionesSubscriber) {
      this.nivelacionesSubscriber.unsubscribe();
    }
  }

  cambiarMes(mes) {
    this.router.navigate(['nivelaciones', 'mis-nivelaciones', 'mes', mes]);
  }

  setConflictos(fecha, conflicto) {
    this.nivelaciones.map(nivelacion => {
      nivelacion.alumnos.map(alumno => {
        alumno.franjas.map(franja => {
          franja.fechas.map(fechaX => {
            if (fechaX.fechaHoraCompleta === fecha.fechaHoraCompleta && fechaX.id !== fecha.id) {
              fechaX.conflicto = fecha.citado ? conflicto : null;
            }
          });
        });
      });
    });
  }

  cambiarCitacion(event, fecha, nombreMateria, profesores) {
    fecha.citado = event.checked;
    const conflicto = {isConflicto: event.checked, materia: nombreMateria, profesor: ''};
    profesores.map(profesor => {
      conflicto.profesor += `${profesor.nombresApellidos} `;
    });

    this.nivelacionesService.setEstadoCitacionNivelacion(fecha).subscribe(res => {
      fecha['id'] = res['id'];
      this.setConflictos(fecha, conflicto);
      this.snackBar.open(`Alumno ${fecha.citado ? 'citado' : 'no citado'} correctamente.`, null, {duration: 2500});
    }, err => {
      fecha.citado = !event.checked;
      event.source._checked = !event.checked;
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible actualizar la citación. <br> ${err.error} Código de error: ${err.statusText}`
      });
    });
  }
}
